import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import './TestInstructionsModal.scss';

/**
 * TestInstructionsModal - Full screen modal showing test instructions
 */
const eomrInstructions = `
1. Read each question carefully before selecting your answer.
2. Each question will have multiple options. Select the circle corresponding to the option you consider correct.
3. To mark an answer, click/tap on the circle next to the selected option. The selected circle will be highlighted.
4. Only one option should be selected for each question unless the question specifically states otherwise.
5. If you change your mind, you may deselect the previously selected option and select another option before submitting the exam.
6. Make sure that your selected answer is clearly highlighted before moving to the next question.
7. You may use the Next/Previous buttons to navigate between questions, if available.
8. Keep track of unanswered questions using the question navigation panel, if provided.
9. Do not refresh the page, close the browser, or use the browser's Back button during the examination unless instructed by the invigilator.
10. Ensure that you have a stable internet connection throughout the examination.
11. If you experience any technical problem, immediately inform the invigilator/exam administrator. Do not attempt to resolve the issue by refreshing or closing the examination window.
12. Before submitting, review your answers carefully and make sure you have answered all questions you intend to attempt.
13. Click Submit/Finish Exam only after you are satisfied with your answers.
14. Once the examination is submitted, you may not be able to change your answers.
15. Follow all examination rules and instructions given by the invigilator.

Important
Select the circle against the correct option — just as you would fill a circle on a traditional OMR sheet.

Good luck!`
const TestInstructionsModal = ({
  show,
  testName,
  testInstructions,
  onProceed,
  onClose,
  isEomr
}) => {
  console.log(testInstructions, 'ti')
  return (
    <Modal
      show={show}
      centered
      fullscreen
      backdrop='static'
      keyboard={false}
      className='TestInstructionsModal'
    >
      <Modal.Body className='TestInstructionsModal__body my-4 w-100' style={{width: '100vw', height: '100vh'}}>
        <div className='TestInstructionsModal__content'>
          <div className='TestInstructionsModal__header'>
            <h1 className='TestInstructionsModal__title text-center'>Please read the instructions carefully</h1>
          </div>

          <div className='TestInstructionsModal__instructions'>
            <h2 className='TestInstructionsModal__instructionsTitle'>General Instructions:</h2>
            <div
              className='TestInstructionsModal__instructionsText'
              dangerouslySetInnerHTML={{ __html: isEomr ? eomrInstructions.replaceAll('\n','<br />') : testInstructions.replaceAll('\n','<br />') || 'No instructions provided.' }}
            />
          </div>

          <div className='TestInstructionsModal__actions'>
            {onClose && (
              <Button
                variant='customSecondarySquare'
                onClick={onClose}
              >
                Close
              </Button>
            )}
            <Button
              variant='customPrimarySquare'
              onClick={onProceed}
            >
              Proceed
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default TestInstructionsModal;
